import React from 'react';
import { motion } from 'framer-motion';
// Data
import { altGalleryImagesArray } from '../../utils/data/GalleryData';

// Example image URLs – swap with your actual ones or imports

const ScrollingImages = () => {
  return (
    <section className='grid w-full border-b-2 border-t-2 border-solid border-colour7 z-30 bg-colour2'>
      <div className='grid w-full py-16'>
        <div className='relative grid overflow-hidden'>
          <motion.div
            className='flex space-x-6'
            animate={{ x: ['0%', '-50%'] }}
            transition={{
              repeat: Infinity,
              ease: 'linear',
              duration: 60,
            }}
          >
            {altGalleryImagesArray.map((item) => (
              <div key={item.src} className='grid items-center justify-center'>
                <img
                  src={item.src}
                  alt={item.alt}
                  aria-label={item.aria}
                  loading='lazy'
                  decoding='async'
                  className='w-full min-w-44 lg:min-w-52 h-full object-cover rounded-lg shadow'
                />
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ScrollingImages;
